export function leftPad (numberValue, targetLength) {
    let output = numberValue + '';

    while (output.length < targetLength) {
        output = '0' + output;
    }

    return output;
}



// WEBPACK FOOTER //
// ./app/bundles/enterprise-shop/src/api/utils/left-pad.ts